import { Page, Text, View } from '@react-pdf/renderer'
import Html from 'react-pdf-html'
import { OrganizationMember } from '@skop-app/lib-domain/types'

import { OrderModalValues } from '@/types'

import { htmlPdfStyles, styles } from '../pdfStyles'
import { Footer } from '../PDFFooter/pdfFooter.organism'

type PDFSignPageProps = {
  title: string
  description: string
  currentPage: number
  totalPages: number
  order: OrderModalValues
  twoSidesSign?: boolean
  hideFooter?: boolean
  signPage?: boolean
  manager?: OrganizationMember
}

export const PDFSignPage = ({
  title,
  description,
  twoSidesSign,
  order,
  currentPage,
  totalPages,
  hideFooter,
  signPage = true,
  manager,
}: PDFSignPageProps) => {
  const isOrder = order?.type !== 'FAVORITE'

  return (
    <Page size="A4" style={styles.container}>
      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '90%',
        }}
      >
        <View>
          {title && <Text style={styles.title}>{title}</Text>}
          <Html
            stylesheet={{
              ...htmlPdfStyles,
              p: {
                ...htmlPdfStyles.p,
                fontSize: 13,
              },
            }}
          >
            {`<p>${description}</p>`}
          </Html>
        </View>
        {signPage && (
          <View
            style={{
              ...styles.flex,
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '48%' }}>
              {twoSidesSign ? (
                <>
                  <Text
                    style={{
                      fontSize: 10,
                      fontFamily: 'Helvetica',
                    }}
                  >
                    Fait à
                  </Text>
                  <Text
                    style={{
                      fontSize: 10,
                      marginTop: 10,
                      marginBottom: 12,
                      fontFamily: 'Helvetica',
                    }}
                  >
                    le
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      marginBottom: 12,
                      fontFamily: 'Helvetica-Bold',
                    }}
                  >
                    {manager?.name ||
                      order?.shop?.user?.name ||
                      order?.shop?.organization?.name}
                  </Text>
                  <Text
                    style={{
                      fontSize: 10,
                      marginBottom: 12,
                      fontFamily: 'Helvetica',
                    }}
                  >
                    Signature du {isOrder ? 'Vendeur' : 'Cédant'} :
                  </Text>
                </>
              ) : null}
            </View>
            <View style={{ width: '48%' }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: 'Helvetica',
                }}
              >
                Fait à
              </Text>
              <Text
                style={{
                  fontSize: 10,
                  marginTop: 10,
                  marginBottom: 12,
                  fontFamily: 'Helvetica',
                }}
              >
                le
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  marginBottom: 12,
                  fontFamily: 'Helvetica-Bold',
                }}
              >
                {order?.name}
              </Text>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: 'Helvetica',
                  marginBottom: 12,
                }}
              >
                Signature{' '}
                {twoSidesSign &&
                  (isOrder ? "de l'acheteur" : 'du Cessionnaire')}{' '}
                :
              </Text>
            </View>
          </View>
        )}
      </View>
      {!hideFooter && (
        <Footer
          label={isOrder ? 'Devis généré par' : 'Bon de cession généré par'}
          currentPage={currentPage}
          totalPages={totalPages}
        />
      )}
    </Page>
  )
}
